// extracted by mini-css-extract-plugin
export var iconContainer = "icon-list-module--iconContainer--07550";
export var iconList = "icon-list-module--iconList--4ddd1";
export var iconText = "icon-list-module--iconText--fc12c";